<template>
  <OneCTTextImageFull
    :image="mgnlPropsWithBtnColors.image"
    :image-title="mgnlPropsWithBtnColors.imageTitle"
    :image-link="mgnlPropsWithBtnColors.imageLink"
    :alt="mgnlPropsWithBtnColors.alt"
    :max-image-height="mgnlPropsWithBtnColors.maxImageHeight"
    :text-position="mgnlPropsWithBtnColors.textPosition"
    :top-title="mgnlPropsWithBtnColors.topTitle"
    :top-title-color="mgnlPropsWithBtnColors.topTitleColor"
    :title="mgnlPropsWithBtnColors.title"
    :title-color="mgnlPropsWithBtnColors.titleColor"
    :sub-text="mgnlPropsWithBtnColors.subText"
    :sub-text-color="mgnlPropsWithBtnColors.subTextColor"
    :cta-link="mgnlPropsWithBtnColors.ctaLink"
    :cta-text-color="mgnlPropsWithBtnColors.ctaTextColor"
    :button-color="mgnlPropsWithBtnColors.buttonColor"
    :border-color="mgnlPropsWithBtnColors.borderColor"
    :image-load-type="(mgnlPropsWithBtnColors.imageLoadType as ('eager' | 'lazy'))"
    :data-ab-id="mgnlProps?.dataABId"
  />
</template>

<script lang="ts" setup>
import { OneCTTextImageFullBuilder, WrapperProps } from './OneCTTextImageFull.model';
import OneCTTextImageFull from './OneCTTextImageFull.vue';
import magnoliaGetters from '~/composables/getters/magnoliaGetters';

const props = defineProps({
  ...WrapperProps, pageLink: Object, ctaText: String, ctaTargetMode: String, pdfLinkInDam: Object, showCtaAsPdf: Boolean,
});

const {
  topTitleColor, titleColor, subTextColor,
} = toRefs(props);

const mgnlProps = {
  ...OneCTTextImageFullBuilder.build(props),
  topTitleColor: magnoliaGetters.getHexColor(topTitleColor?.value),
  titleColor: magnoliaGetters.getHexColor(titleColor?.value),
  subTextColor: magnoliaGetters.getHexColor(subTextColor?.value),
};

if (props.pageLink && !props.ctaLink) {
  magnoliaGetters.migratePageLinkToCtaLink(mgnlProps, props);
}

const mgnlPropsWithBtnColors = {
  ...mgnlProps,
  ctaTextColor: mgnlProps.ctaLink?.[0]?.ctaTextColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.ctaTextColor) : '#3c3c3b',
  buttonColor: mgnlProps.ctaLink?.[0]?.buttonColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.buttonColor) : '#ffffff',
  borderColor: mgnlProps.ctaLink?.[0]?.borderColor ? magnoliaGetters.getHexColor(mgnlProps.ctaLink?.[0]?.borderColor) : '#3c3c3b',
};
</script>
